export function LogoMark({ size = 32, className = "" }) {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" fill="#FF4D00" stroke="#000" strokeWidth="4" />
      <path d="M42.5 13.8 A21 21 0 1 1 18.5 15.9" fill="none" stroke="#000" strokeWidth="5" strokeLinecap="square" />
      <path d="M24.6 10.9 L13.2 11.6 L19.6 21.1 Z" fill="#000" />
      <path d="M22 32 C27 23.5 39 23.5 45 32 C39 40.5 27 40.5 22 32 Z" fill="#000" />
      <path d="M23.5 32 L15.5 25.5 L17.5 32 L15.5 38.5 Z" fill="#000" />
      <circle cx="39.5" cy="30.5" r="2" fill="#FF4D00" />
    </svg>
  );
}

export function Logo({ size = 32, textClass = "text-lg" }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <LogoMark size={size} className="shrink-0" />
      <span className={`font-display uppercase leading-none ${textClass}`}>
        Catch<span className="text-[#FF4D00]">&amp;</span>Release
      </span>
    </span>
  );
}
